import DOMPurify from 'dompurify'
import { withMarkdownEmphasis } from '@/lib/markdown-emphasis'

/**
 * Render sanitized user-authored HTML (e.g. the work-order description produced
 * by the rich-text editor). DOMPurify strips scripts/handlers/unknown tags, so a
 * malicious or malformed stored value can't execute. Never render stored HTML
 * without this. Restricted to the marks the editor can produce.
 *
 * `markdownEmphasis` also renders literal `**bold**` and `*italic*` as emphasis, for
 * text written by a source that stores markdown marks inside its HTML (Workfront).
 */
export function SafeHtml({
	html,
	className,
	markdownEmphasis = false,
}: {
	html: string
	className?: string
	markdownEmphasis?: boolean
}) {
	const clean = DOMPurify.sanitize(html, {
		ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'b', 'i', 'ul', 'ol', 'li', 'a'],
		ALLOWED_ATTR: ['href', 'target', 'rel'],
	})
	const shown = markdownEmphasis ? withMarkdownEmphasis(clean) : clean
	// biome-ignore lint/security/noDangerouslySetInnerHtml: content is sanitized by DOMPurify above
	return <div className={className} dangerouslySetInnerHTML={{ __html: shown }} />
}
